import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  OnField2kq8b4gk936v8 as OnField,
  Equal31pr842ymh8s6 as Equal,
  And1a3dbpwh0hxmu as And,
  Always2gnog82xa5sk4 as Always,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isComparableviyv6ctzm76u as isComparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  maxWithOrNullsohvqg0i6v8s as maxWithOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
  take3onnpy6q7ctcz as take,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { impliesCondition3tegm38vvcvlm as impliesCondition } from './ConditionImplies.mjs';
import { get_comparatornh5qvtuce91z as get_comparator } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortPart.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { _id3hu92r6d2ylpm as _id } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasIdFields.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ensureTotal1k0kavd9th17q as ensureTotal } from './utils.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ExtentClass;
function Extent() {
  if (ExtentClass === VOID) {
    class $ {
      constructor(condition, order) {
        this.condition_1 = condition;
        this.order_1 = order;
      }
      toString() {
        return 'Extent(condition=' + toString(this.condition_1) + ', order=' + toString(this.order_1) + ')';
      }
      hashCode() {
        var result = this.condition_1.hashCode();
        result = imul(result, 31) + hashCode(this.order_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Extent()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!equals(this.order_1, other.order_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Extent');
    ExtentClass = $;
  }
  return ExtentClass;
}
var ClaimClass;
function Claim() {
  if (ClaimClass === VOID) {
    class $ {
      constructor(through, at) {
        this.through_1 = through;
        this.at_1 = at;
      }
    }
    initMetadataForClass($, 'Claim');
    ClaimClass = $;
  }
  return ClaimClass;
}
function idExtent($this, id) {
  return new (Extent())(OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$($this.idProp_1, Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(id)), $this.idOrder_1);
}
function singleId($this, condition) {
  var tmp0_safe_receiver = condition instanceof OnField() ? condition : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (equals(tmp0_safe_receiver.key_1, $this.idProp_1)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_2 = tmp1_safe_receiver.condition_1;
    var tmp0_safe_receiver_0 = tmp_2 instanceof Equal() ? tmp_2 : null;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.value_1;
    tmp_1 = (tmp_3 == null ? true : isComparable(tmp_3)) ? tmp_3 : THROW_CCE();
  }
  return tmp_1;
}
function extent($this, $receiver) {
  return new (Extent())($receiver.condition_1, $receiver.orderBy_1);
}
function effective($this, $receiver) {
  var tmp0_elvis_lhs = $this.masking_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return $receiver.condition_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var mask = tmp;
  var tmp0 = $this.permitSortCache_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = $receiver.order_1;
  var value = tmp0.get_wei43m_k$(key);
  var tmp_0;
  if (value == null) {
    var answer = mask.permitSort_dd32vb_k$($receiver.order_1);
    tmp0.put_4fpzoq_k$(key, answer);
    tmp_0 = answer;
  } else {
    tmp_0 = value;
  }
  var imposed = tmp_0;
  var tmp_1;
  if (imposed instanceof Always()) {
    tmp_1 = $receiver.condition_1;
  } else {
    tmp_1 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([$receiver.condition_1, imposed]));
  }
  return tmp_1;
}
function sortFields($this, order) {
  // Inline function 'kotlin.collections.mapTo' call
  var destination = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
  var _iterator__ex2g4s = order.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$1 = item.field_1;
    destination.add_utx5q5_k$(tmp$ret$1);
  }
  return destination;
}
function orderCovers($this, claimOrder, claim, wantedOrder) {
  return equals(claimOrder, wantedOrder) || (claim.through_1 == null && (!($this.masking_1 == null) || sortFields($this, wantedOrder).containsAll_xk45fg_k$(sortFields($this, claimOrder))));
}
function backing($this, query) {
  var extent_0 = extent($this, query);
  var tmp0_safe_receiver = $this.claims_1.get_wei43m_k$(extent_0);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var wantsOneRow = !(singleId($this, extent_0.condition_1) == null);
  var wanted = effective($this, extent_0);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.claims_1.get_entries_p20ztl_k$();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var e = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var claim = element.get_value_j01efc_k$();
    if ((wantsOneRow || singleId($this, e.condition_1) == null) && orderCovers($this, e.order_1, claim, extent_0.order_1) && implies($this, wanted, effective($this, e))) {
      destination.add_utx5q5_k$(element);
    }
  }
  var tmp = destination;
  var tmp_0 = CoverageStore$backing$lambda;
  var tmp1_safe_receiver = maxWithOrNull(tmp, compareBy([tmp_0, CoverageStore$backing$lambda_0]));
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_value_j01efc_k$();
}
function requireCacheable($this, query) {
  // Inline function 'kotlin.require' call
  if (!(query.limit_1 > 0)) {
    var message = 'A limit of ' + query.limit_1 + ' asks the server for nothing.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(query.skip_1 === 0)) {
    var message_0 = 'A query skipping ' + query.skip_1 + ' rows says nothing about the rows before them.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
}
var AnswerClass;
function Answer() {
  if (AnswerClass === VOID) {
    class $ {
      constructor(items, at, partial) {
        this.items_1 = items;
        this.at_1 = at;
        this.partial_1 = partial;
      }
    }
    initMetadataForClass($, 'Answer');
    AnswerClass = $;
  }
  return AnswerClass;
}
function reachedEndOf($this, result, limit, declared) {
  return declared == null ? result.get_size_woubt6_k$() < limit : declared;
}
function record($this, item, at) {
  if (alreadyKnowBetter($this, item.get__id_18jb1r_k$(), at, item))
    return Unit_instance;
  var tmp0 = $this.items_1;
  // Inline function 'kotlin.collections.set' call
  var key = item.get__id_18jb1r_k$();
  tmp0.put_4fpzoq_k$(key, item);
  var tmp0_0 = $this.claims_1;
  var tmp2 = idExtent($this, item.get__id_18jb1r_k$());
  // Inline function 'kotlin.collections.set' call
  var value = new (Claim())(null, at);
  tmp0_0.put_4fpzoq_k$(tmp2, value);
}
function gone($this, id, at) {
  if (alreadyKnowBetter($this, id, at, null))
    return Unit_instance;
  $this.items_1.remove_gppy8k_k$(id);
  var tmp0 = $this.claims_1;
  var tmp2 = idExtent($this, id);
  // Inline function 'kotlin.collections.set' call
  var value = new (Claim())(null, at);
  tmp0.put_4fpzoq_k$(tmp2, value);
}
function alreadyKnowBetter($this, id, at, incoming) {
  var versionOf = $this.versionOf_1;
  if (!(versionOf == null) && !(incoming == null)) {
    var tmp0_safe_receiver = $this.items_1.get_wei43m_k$(id);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = versionOf(tmp0_safe_receiver);
    }
    var held = tmp;
    var offered = versionOf(incoming);
    if (!(held == null) && !(offered == null))
      return held > offered;
  }
  var tmp1_safe_receiver = $this.claims_1.get_wei43m_k$(idExtent($this, id));
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.at_1;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = tmp2_safe_receiver.compareTo_stdc3w_k$(at) > 0;
  }
  return tmp_0 === true;
}
function implies($this, narrow, broad) {
  return impliesCondition(narrow, broad);
}
function reconcile($this, condition, order, after, through, returned, at) {
  var comparator = ensureNotNull(get_comparator(order));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
  var _iterator__ex2g4s = returned.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$1 = item.get__id_18jb1r_k$();
    destination.add_utx5q5_k$(tmp$ret$1);
  }
  var returnedIds = destination;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.items_1.get_values_ksazhn_k$();
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s_0.next_20eer_k$();
    if (!returnedIds.contains_aljjnj_k$(element.get__id_18jb1r_k$()) && condition.invoke_wbynzd_k$(element) && !alreadyKnowBetter($this, element.get__id_18jb1r_k$(), at, null) && (after == null || comparator.compare(element, after) > 0) && (through == null || comparator.compare(element, through) <= 0)) {
      destination_0.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = destination_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
    $this.items_1.remove_gppy8k_k$(element_0.get__id_18jb1r_k$());
    var tmp = $this.claims_1.get_keys_wop4xp_k$();
    removeAll(tmp, CoverageStore$reconcile$lambda($this, element_0));
  }
}
function CoverageStore$backing$lambda(it) {
  return it.get_value_j01efc_k$().through_1 == null ? 1 : 0;
}
function CoverageStore$backing$lambda_0(it) {
  return it.get_value_j01efc_k$().at_1;
}
function CoverageStore$socketDelta$lambda(this$0, $old, $live) {
  return (_destruct__k2r9zo) => {
    // Inline function 'kotlin.collections.component1' call
    var extent = _destruct__k2r9zo.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var claim = _destruct__k2r9zo.get_value_j01efc_k$();
    return effective(this$0, extent).invoke_wbynzd_k$($old) && !$live(extent.condition_1, claim.at_1);
  };
}
function CoverageStore$reconcile$lambda(this$0, $stale) {
  return (it) => effective(this$0, it).invoke_wbynzd_k$($stale);
}
var CoverageStoreClass;
function CoverageStore() {
  if (CoverageStoreClass === VOID) {
    class $ {
      constructor(serializer, versionOf) {
        versionOf = versionOf === VOID ? null : versionOf;
        this.versionOf_1 = versionOf;
        this.idProp_1 = _id(serializer);
        this.items_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.claims_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.updates_1 = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp.idOrder_1 = ensureTotal(tmp$ret$0, serializer);
        this.masking_1 = null;
        this.permitSortCache_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      idQuery_k1til4_k$(id) {
        return new (Query())(OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(this.idProp_1, Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(id)), this.idOrder_1, VOID, 1);
      }
      useMasking_atm68g_k$(mask) {
        if (equals(this.masking_1, mask))
          return Unit_instance;
        this.masking_1 = mask;
        this.permitSortCache_1.clear_j9egeb_k$();
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!mask.pairs_1.isEmpty_y1axqb_k$()) {
          this.invalidate_p4aufp_k$();
        } else {
          this.updates_1.invokeAll_w2le0p_k$();
        }
      }
      known_ahtola_k$(query) {
        requireCacheable(this, query);
        var extent_0 = extent(this, query);
        var tmp0_elvis_lhs = backing(this, query);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var claim = tmp;
        var effective_0 = effective(this, extent_0);
        if (claim.through_1 == null) {
          var tmp1_safe_receiver = singleId(this, query.condition_1);
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver = this.items_1.get_wei43m_k$(tmp1_safe_receiver);
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.takeIf' call
              var tmp_1;
              if (effective_0.invoke_wbynzd_k$(tmp0_safe_receiver)) {
                tmp_1 = tmp0_safe_receiver;
              } else {
                tmp_1 = null;
              }
              tmp_0 = tmp_1;
            }
            var row = tmp_0;
            return new (Answer())(listOfNotNull(row), claim.at_1, false);
          }
        }
        var comparator = ensureNotNull(get_comparator(query.orderBy_1));
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.items_1.get_values_ksazhn_k$();
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (effective_0.invoke_wbynzd_k$(element)) {
            destination.add_utx5q5_k$(element);
          }
        }
        var matching = sortedWith(destination, comparator);
        var tmp2_safe_receiver = claim.through_1;
        var tmp_2;
        if (tmp2_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.takeWhile' call
          var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_0 = matching.iterator_jk1svi_k$();
          $l$loop: while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_0.next_20eer_k$();
            if (!(comparator.compare(item, tmp2_safe_receiver) <= 0))
              break $l$loop;
            list.add_utx5q5_k$(item);
          }
          tmp_2 = list;
        }
        var tmp3_elvis_lhs = tmp_2;
        var reached = tmp3_elvis_lhs == null ? matching : tmp3_elvis_lhs;
        return new (Answer())(take(reached, query.limit_1), claim.at_1, !(claim.through_1 == null) && reached.get_size_woubt6_k$() < query.limit_1);
      }
      queried_tdjhhy_k$(query, result, at, reachedEnd) {
        requireCacheable(this, query);
        var extent_0 = extent(this, query);
        var through = reachedEndOf(this, result, query.limit_1, reachedEnd) ? null : lastOrNull(result);
        reconcile(this, effective(this, extent_0), query.orderBy_1, null, through, result, at);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = result.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          record(this, element, at);
        }
        var tmp0 = this.claims_1;
        // Inline function 'kotlin.collections.set' call
        var value = new (Claim())(through, at);
        tmp0.put_4fpzoq_k$(extent_0, value);
        this.updates_1.invokeAll_w2le0p_k$();
      }
      queried$default_py8gr4_k$(query, result, at, reachedEnd, $super) {
        reachedEnd = reachedEnd === VOID ? null : reachedEnd;
        var tmp;
        if ($super === VOID) {
          this.queried_tdjhhy_k$(query, result, at, reachedEnd);
          tmp = Unit_instance;
        } else {
          tmp = $super.queried_tdjhhy_k$.call(this, query, result, at, reachedEnd);
        }
        return tmp;
      }
      identified_ppvmce_k$(found, missing, at) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = found.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          record(this, element, at);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = missing.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          gone(this, element_0, at);
        }
        this.updates_1.invokeAll_w2le0p_k$();
      }
      mutated_37iclx_k$(changed, at) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = changed.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          record(this, element, at);
        }
        this.updates_1.invokeAll_w2le0p_k$();
      }
      deleted_qylqew_k$(ids, at) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = ids.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          gone(this, element, at);
        }
        this.updates_1.invokeAll_w2le0p_k$();
      }
      socketDelta_xhb3vg_k$(changed, removed, at, live) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = changed.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          record(this, element, at);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = removed.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          $l$block: {
            var tmp0_elvis_lhs = this.items_1.remove_gppy8k_k$(element_0);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              break $l$block;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var old = tmp;
            this.claims_1.remove_gppy8k_k$(idExtent(this, element_0));
            var tmp_0 = this.claims_1.get_entries_p20ztl_k$();
            removeAll(tmp_0, CoverageStore$socketDelta$lambda(this, old, live));
          }
        }
        this.updates_1.invokeAll_w2le0p_k$();
      }
      invalidate_p4aufp_k$() {
        this.items_1.clear_j9egeb_k$();
        this.claims_1.clear_j9egeb_k$();
        this.updates_1.invokeAll_w2le0p_k$();
      }
    }
    initMetadataForClass($, 'CoverageStore');
    CoverageStoreClass = $;
  }
  return CoverageStoreClass;
}
//region block: exports
export {
  CoverageStore as CoverageStore2039zzqixnpei,
};
//endregion

//# sourceMappingURL=CoverageStore.mjs.map
